export function hasNextSlide() {
    let item_current = +$('.service.active').find('.owl-item.active .item').attr('data');
    let item_count = $('.service.active').find('.owl-item').length;

    return item_current < item_count
}

export function hasPrevSlide() {
    let item_current = +$('.service.active').find('.owl-item.active .item').attr('data');

    return item_current > 1
}

export function setServiceActive(id) {
    const services = $('.service');
    services.removeClass('active');
    services.filter('[data=' + id + ']').find('.owl-carousel').trigger('to.owl.carousel', [0, 600]);
    services.filter('[data=' + id + ']').toggleClass('active');

    $('#services-menu li').removeClass('active');
    $('#services-menu a').filter('[data=' + id + ']').closest('li').toggleClass('active');

}

(function () {
    let end = false;
    let loading_in_process = false;

    function getAjaxTracks(list, page, number, loading) {
        loading_in_process = true;
        loading.addClass('lds-dual-ring');

        let form_data = [];

        form_data.push({ name: 'page', value: page });
        form_data.push({ name: 'number', value: number });
        form_data.push({ name: 'action', value: 'tracks_loading' });

        $.ajax({
            type: 'post',
            url: theme.ajaxurl,
            dataType: 'json',
            data: form_data,
            beforeSend: function () {
            },
            success: function (response) {
                if (response.state == true) {
                    $(response.html).appendTo(list);
                } else {
                    end = true;
                }

            },
            error: function (response) {
                console.log(response);
            },
            complete: function () {
                loading_in_process = false;
                loading.removeClass('lds-dual-ring');
            }
        });
    }

    function serviceClick(obj, e) {
        e.preventDefault();
        let id = obj.attr('data');
        setServiceActive(id);
    }

    jQuery(document).ready(function ($) {
        $('.menu-trigger').on('click', function () {

            $('.header_menu').fadeToggle(400);
        });

        $('#services-menu a').click(function (e) {
            serviceClick($(this), e);
        });

        $('#services-arrows a').click(function (e) {
            e.preventDefault();

            const service_active = $('.service.active');

            let data = $(this).attr('data');
            service_active.find('.service-carousel').trigger(data + '.owl.carousel');
        });


        $('.post-item .square-button').click(function (e) {
            $(this).closest('.post-item').toggleClass('active');
        });

        $('.post-wrapper .square-button').click(function (e) {
            let current = $(this).closest('.post-wrapper');
            let data = current.attr('data');

            current.toggleClass('active');

            $('.post-wrapper:not([data=' + data + '])').removeClass('active');
        });

        $('.person .photo').click(function (e) {
            $('.person.active').removeClass('active');
            const button = $(this).find('.square-button');

            const popup_active = $('.person_popup.active');

            const person = button.closest('.person');
            let id = person.attr('data');

            if (!popup_active.length) {
                person.addClass('active');

                let top = button.offset().top + 60;
                const popup = $('.person_popup').filter('[data=' + id + ']');
                popup.css('top', top);
                popup.addClass('active');
                popup.fadeIn();
            } else {
                if (popup_active.attr('data') === id) {
                    popup_active.removeClass('active');
                    $('.person').removeClass('active');

                    popup_active.fadeOut();
                    return;
                }
                popup_active.fadeOut(400, function () {
                    $('.person_popup').removeClass('active');
                    $('.person').removeClass('active');

                    const person = button.closest('.person');
                    person.toggleClass('active');

                    let id = person.attr('data');
                    let top = button.offset().top + 60;
                    const popup = $('.person_popup').filter('[data=' + id + ']');
                    popup.css('top', top);
                    popup.addClass('active');
                    popup.fadeIn();
                });
            }
        });

        $('#track_show_more, #tracks-loading').click(function (e) {
            e.preventDefault();

            if (end) return;
            if (loading_in_process) return;

            const list = $('#track-list');
            if (!list.length) return;

            const loading = $('#tracks-loading');

            let number_per_page = 2;
            let items = list.find('.track').length;
            let current_page = items / number_per_page;
            current_page = current_page % 1 > 0 ? current_page + 1 : current_page;

            getAjaxTracks(list, current_page, number_per_page, loading)
        });

        $('#tracks-loading').click(function (e) {
            e.preventDefault();
        });
    });
    jQuery(window).on('resize', function () {
        $('.person_popup.active').each(function () {
            let top = $('.person.active .square-button').offset().top + 60;
            const popup = $(this);
            popup.css('top', top);
        });
    });
    jQuery(document).click(function (e) {
        if (!$(e.target).closest(".photo, .popup_content").length) {
            const person_popup = $('.person_popup.active');
            person_popup.fadeOut();
            person_popup.removeClass('active');
            $('.person.active').removeClass('active');
        }
    });
    jQuery(document).click(function (e) {
        if (!$(e.target).closest(".news_popup .popup_content, .post-item .square-button").length) {
            $('.post-item').removeClass('active');
        }
    });
})();
